export default __webpack_public_path__ + "static/media/expressBW.6de77bbd.webp";